export default [
  "ABARTH",
  "ACURA",
  "AIXAM",
  "ALFA_ROMEO",
  "ALPINA",
  "ALPINE",
  "AMC",
  "ANHAENGER",
  "ASIA_MOTORS",
  "ASTON_MARTIN",
  "AUDI",
  "AUSTIN",
  "AUSTIN_HEALY",
  "AUSTIN_ROVER",
  "BENTLEY",
  "BMW",
  "BMW_MOTORRAD",
  "BORGWARD",
  "BRILLIANCE",
  "BRITISH_LEYLAND",
  "BUGATTI",
  "BUICK",
  "BYD",
  "CADILLAC",
  "CATERHAM",
  "CHANGAN",
  "CHERY",
  "CHEVROLET",
  "CHRYSLER",
  "CITROEN",
  "COBRA",
  "CORVETTE",
  "DACIA",
  "DAEWOO",
  "DAIHATSU",
  "DERBI",
  "DETHLEFFS",
  "DE_TOMASO",
  "DODGE",
  "DS",
  "FAHRRAD",
  "FERRARI",
  "FIAT",
  "FIAT_PROFESSIONAL",
  "FIREFLY",
  "FORD",
  "FREMDMARKE",
  "GEBRAUCHTWAGEN",
  "GILERA",
  "GMC",
  "HARLEY_DAVIDSON",
  "HOLDEN",
  "HONDA",
  "HUMMER",
  "HYUNDAI",
  "INFINITY",
  "INNOCENTI",
  "ISUZU",
  "IVECO",
  "JAECOO",
  "JAGUAR",
  "JEEP",
  "KEEWAY",
  "KIA",
  "LADA",
  "LAMBORGHINI",
  "LANCIA",
  "LANDROVER",
  "LANDWIND",
  "LEXUS",
  "LIGIER",
  "LINCOLN",
  "LOTUS",
  "MAHINDRA",
  "MASERATI",
  "MAXUS",
  "MAYBACH",
  "MAZDA",
  "MERCEDES",
  "MERCURY",
  "MG",
  "MINI",
  "MITSUBISHI",
  "MOBILIZE",
  "MORGAN",
  "MOTO_GUZZI",
  "NIO",
  "NISSAN",
  "NO_BRAND",
  "NSU",
  "OJ",
  "OLDSMOBILE",
  "OPEL",
  "PAGANI",
  "PEUGEOT",
  "PIAGGIO",
  "PIAGGIO_AUTOMOTIVE",
  "PLYMOUTH",
  "POLESTAR",
  "PONTIAC",
  "PORSCHE",
  "PROTON",
  "PUCH",
  "QVALE",
  "RENAULT",
  "RENAULT_TRUCKS",
  "ROLLS_ROYCE",
  "ROVER",
  "SAAB",
  "SANTANA",
  "SAUBER",
  "SCARABEO",
  "SEAT",
  "SKODA",
  "SMART",
  "SSANGYONG",
  "STEYR_PUCH",
  "SUBARU",
  "SUZUKI",
  "TALBOT",
  "TATA",
  "TOYOTA",
  "TRABANT",
  "TRIUMPH",
  "TVR",
  "US",
  "VESPA",
  "VOLVO",
  "VW",
  "WARTBURG",
  "WIESMANN",
  "XPENG",
];
